import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Chip } from "@material-ui/core";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import moment from "moment";

const styles = (theme) => ({
  container: {
    padding: 5,
    paddingLeft: 1,
    paddingRight: 1,
    minHeight: "100%",
  },
  chip: {
    color: "rgb(0 94 108)",
    fontSize: "16px",
    marginBottom: "12px",
    borderRadius: "4px",
  },
  deleteIcon: {
    fill: "rgb(0 94 108)",
  },
});

class AdvancedSearchSummary extends React.Component {
  constructor(props) {
    super();
    this.onDelete = this.onDelete.bind(this);
  }

  onDelete = (selection) => {
    const { searchCriteria, summaryValues } = this.state;
    const updatedSummary = summaryValues.filter(
      (item) => item.label !== selection.label,
    );
    const updatedCriteria = { ...searchCriteria };
    delete updatedCriteria[selection.label];
    if (
      selection.label === "duration" ||
      selection.label === "numberOf" ||
      selection.label === "dateSelection"
    ) {
      delete updatedCriteria.numberOf;
      delete updatedCriteria.dateSelection;
    }
    this.setState({
      summaryValues: updatedSummary,
      searchCriteria: updatedCriteria,
    });
  };

  getRegionName(value) {
    let name;
    this.props.advancedSearchFields.forEach((row) => {
      row.elements.forEach((field) => {
        if (field.label == "regionId") {
          let selectedOption = field.options.filter(
            (op) => op.siteGroupId == value,
          );
          name = selectedOption[0].siteGroupName;
        }
      });
    });
    return name;
  }

  formatValue(label, value) {
    if (label === "fromDate" || label === "toDate") {
      return moment(value).format("DD/MMM/YYYY"); // formats timestamp
    }
    if (label === "regionId") {
      return this.getRegionName(value); // existing logic
    }
    if (label === "numberOf") {
      const durationTypeSelection = this.props.selectedValues.find(
        (sel) => sel.label === "selectedDurationValue",
      );
      const durationType = durationTypeSelection
        ? durationTypeSelection.value
        : "";
      return `Last ${value} ${durationType}`;
    }
    return value;
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        {this.props.selectedValues.map((selection, index) => (
          <Chip
            key={index}
            size="small"
            className={classes.chip}
            label={this.formatValue(selection.label, selection.value)}
            variant="outlined"
            onDelete={() => this.props.onDelete(selection)}
            deleteIcon={
              <RemoveCircleOutline
                fontSize="small"
                className={classes.deleteIcon}
              />
            }
          />
        ))}
      </div>
    );
  }
}

export { AdvancedSearchSummary };
export default withStyles(styles)(AdvancedSearchSummary);
